/*
 * Translation file for multi-locale
 * ---------------------------------
 * Struct:
 * es : {
 *    // Common labeling Block
 *    common: {
 *       lbl1: 'YYYYY'
 *    },
 *    // Pages Block --> Seguir nombres de pages
 *    pages: {
 *       about: {
 *          lbl1: 'ZZZZ'
 *       }
 *    },
 *    // Compnents block --> Seguir misma estructura que ficheros
 *    components: {
 *       home: {
 *          NavigationBarComponent : {
 *              lbl1: 'XXXX'
 *          }
 *       }
 *    }
 * }
 *
 * */

import { es } from "@/shared/services/i18n/es";
import { en } from "@/shared/services/i18n/en";
import { pt } from "@/shared/services/i18n/pt";
import { it } from "@/shared/services/i18n/it";

const Translations = {
  es,
  en,
  it,
  pt,
};

export default Translations;
